<div *ngIf="spinnerShow">
    <div *ngIf="spinnerType=='plane'" class="sk-spinner sk-spinner-rotating-plane"></div>

    <div *ngIf="spinnerType=='dbBounce'" class="sk-spinner sk-spinner-double-bounce">
        <div class="sk-double-bounce1"></div>
        <div class="sk-double-bounce2"></div>
    </div>

    <div *ngIf="!spinnerType || spinnerType=='wave'" class="sk-spinner sk-spinner-wave">
        <div class="sk-rect1"></div>
        <div class="sk-rect2"></div>
        <div class="sk-rect3"></div>
        <div class="sk-rect4"></div>
        <div class="sk-rect5"></div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/spinner/spinner.component.html